var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { of as rxOf } from "rxjs/observable/of";
import { from as rxFrom } from "rxjs/observable/from";
import { concatMap, catchError, tap, map, toArray, take } from "rxjs/operators";
import { WEBGL2, GLTF } from "../webgl2/webgl2-token";
import { Material } from "./material";
import { Texture2d } from "./texture-2d";
import { Sampler } from "./sampler";
var MaterialLoader = (function () {
    function MaterialLoader(http_client_, gl_context_, gltf_data_) {
        this.http_client_ = http_client_;
        this.gl_context_ = gl_context_;
        this.gltf_data_ = gltf_data_;
        this.relative_path_regex = /^([^.]*)(?:\.)(?:jpeg|png)/;
        this.texture_cache_ = [];
        this.createDefaultTexture();
        this.createDefaultSampler();
        this.createSamplers();
    }
    MaterialLoader.prototype.getMaterial = function (material_index) {
        var _this = this;
        return this.loadTexturesForMaterial(material_index)
            .pipe(take(1), map(function (textures) {
            var material = new Material(_this.gl_context_, _this.gltf_data_, _this);
            material.setTextures(material_index);
            return material;
        }));
    };
    ;
    MaterialLoader.prototype.getTexture = function (texture_index) {
        var texture = this.gltf_data_.textures[texture_index];
        if (texture) {
            var source_index = texture.source;
            return this.texture_cache_[source_index];
        }
        return this.default_texture_;
    };
    ;
    MaterialLoader.prototype.getSampler = function (texture_index) {
        var texture = this.gltf_data_.textures[texture_index];
        if (texture) {
            var sampler_index = texture.sampler;
            if (sampler_index) {
                return this.samplers_[sampler_index];
            }
        }
        return this.default_sampler_;
    };
    ;
    ;
    MaterialLoader.prototype.loadTexturesForMaterial = function (material_index) {
        var _this = this;
        if (!(this.gltf_data_.materials instanceof Array)) {
            return rxOf([]);
        }
        var material = this.gltf_data_.materials[material_index];
        if (!material) {
            return rxOf([]);
        }
        var texture_indices = [
            material.pbrMetallicRoughness && material.pbrMetallicRoughness.baseColorTexture,
            material.pbrMetallicRoughness && material.pbrMetallicRoughness.metallicRoughnessTexture,
            material.normalTexture, material.occulsionTexture, material.emissiveTexture
        ].filter(function (texture) { return !!texture; }).map(function (texture) { return texture.index; });
        return rxFrom(texture_indices)
            .pipe(map(function (texture_index) { return _this.gltf_data_.textures[texture_index].source; }), concatMap(function (source) {
            return _this.loadTexture(source);
        }), toArray());
    };
    ;
    MaterialLoader.prototype.preloadAllTextures = function () {
        var _this = this;
        this.clearCache();
        return rxFrom(this.gltf_data_.images)
            .pipe(concatMap(function (source, index) {
            return _this.loadTexture(index);
        }));
    };
    ;
    MaterialLoader.prototype.loadTexture = function (index) {
        var _this = this;
        var texture = this.texture_cache_[index];
        if (texture) {
            return rxOf(texture);
        }
        var image_source = this.gltf_data_.images[index];
        var uri = image_source.uri;
        if (typeof uri === "string") {
            var scheme = uri.split(";");
            if (scheme[0] === "data:image/png" || scheme[0] === "data:image/jpeg") {
                var data = uri.split(",")[1];
                var is_base_64 = scheme[1].split(",")[0] === "base64";
                var array = this.decodeImageDataURI(data, is_base_64);
                var texture_1 = new Texture2d(this.gl_context_);
                texture_1.uploadTextureData(array);
                this.texture_cache_[index] = texture_1;
                return rxOf(texture_1);
            }
            else {
                if (this.relative_path_regex.test(uri)) {
                    return this.http_client_.get(uri, { responseType: "blob" })
                        .pipe(concatMap(function (blob) {
                        return createImageBitmap(blob);
                    }), map(function (image) {
                        var texture = new Texture2d(_this.gl_context_);
                        texture.uploadTextureData(image);
                        return texture;
                    }), tap(function (texture) {
                        _this.texture_cache_[index] = texture;
                    }), catchError(this.handleError));
                }
                else {
                    console.warn("Invalid image uri: " + JSON.stringify(image_source) + ".");
                    return this.handleError(null);
                }
            }
        }
        else if (typeof image_source.bufferView === "number" &&
            (image_source.mimeType === "image/jpeg" || image_source.mimeType === "image/png")) {
            return this.handleError(null);
        }
        else {
            console.warn("Failed to locate texture: " + JSON.stringify(image_source) + ".");
            return this.handleError(null);
        }
    };
    ;
    MaterialLoader.prototype.createSamplers = function () {
        var _this = this;
        if (!(this.gltf_data_.samplers instanceof Array))
            return;
        this.samplers_ = this.gltf_data_.samplers.map(function (data, index) {
            var sampler = new Sampler(_this.gl_context_);
            sampler.setParametersFromData(data);
            return sampler;
        });
    };
    ;
    MaterialLoader.prototype.decodeImageDataURI = function (data, is_base_64) {
        var decoded_text = decodeURIComponent(data);
        var byte_string = decoded_text;
        if (is_base_64) {
            byte_string = atob(decoded_text);
        }
        var array = new Uint8Array(byte_string.length);
        for (var i = 0; i < byte_string.length; i++) {
            array[i] = byte_string.charCodeAt(i);
        }
        return array;
    };
    ;
    MaterialLoader.prototype.createPattern = function () {
        var row_size, section, row, offset, count, color, i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    row_size = 512;
                    section = row_size / 8;
                    row = 0;
                    _a.label = 1;
                case 1:
                    if (!(row < row_size)) return [3, 10];
                    offset = (Math.trunc(row / section) % 2);
                    count = 0;
                    _a.label = 2;
                case 2:
                    if (!(count < row_size)) return [3, 9];
                    color = void 0;
                    if (offset) {
                        color = 255 * (Math.trunc(count / section) % 2);
                    }
                    else {
                        color = 255 * ((1 + Math.trunc(count / section)) % 2);
                    }
                    i = 0;
                    _a.label = 3;
                case 3:
                    if (!(i < 3)) return [3, 6];
                    return [4, color];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    i++;
                    return [3, 3];
                case 6: return [4, 255];
                case 7:
                    _a.sent();
                    _a.label = 8;
                case 8:
                    count++;
                    return [3, 2];
                case 9:
                    row++;
                    return [3, 1];
                case 10: return [2];
            }
        });
    };
    ;
    MaterialLoader.prototype.createDefaultTexture = function () {
        var array = new Uint8ClampedArray(this.createPattern());
        var image_data = new ImageData(array, 512, 512);
        this.default_texture_ = new Texture2d(this.gl_context_);
        this.default_texture_.uploadTextureData(image_data);
    };
    ;
    MaterialLoader.prototype.createDefaultSampler = function () {
        this.default_sampler_ = new Sampler(this.gl_context_);
        this.default_sampler_.setParameters("LINEAR_MIPMAP_LINEAR", "LINEAR", "CLAMP_TO_EDGE");
    };
    ;
    MaterialLoader.prototype.handleError = function (err) {
        return rxOf(this.default_texture_);
    };
    ;
    MaterialLoader.prototype.clearCache = function () {
        this.texture_cache_.length = 0;
    };
    ;
    MaterialLoader.decorators = [
        { type: Injectable },
    ];
    MaterialLoader.ctorParameters = function () { return [
        { type: HttpClient, },
        { type: WebGL2RenderingContext, decorators: [{ type: Inject, args: [WEBGL2,] },] },
        { type: undefined, decorators: [{ type: Inject, args: [GLTF,] },] },
    ]; };
    return MaterialLoader;
}());
export { MaterialLoader };
;
//# sourceMappingURL=material-loader.js.map